export default {
  keyMaps: {
    '<up>': 'previous-item',
    '<down>': 'next-item',
    '<right>': 'expand-item',
    '<left>': 'collapse-item',
    '<return>': 'toggle-expansion',
    'Shift-<right>': 'view-item',
    '<space>': 'done-undone-item',
    '<escape>': 'cancel-editing',
    'Ctrl-<delete>': 'delete-initiative',
    e: 'edit-initiative',
    c: 'comment'
  },
  categoryDefinitions: [
    { name: 'previous-item', description: 'Go to previous initiative' },
    { name: 'next-item', description: 'Go to next initiative' },
    { name: 'expand-item', description: 'Expand selected initiative' },
    { name: 'collapse-item', description: 'Collapse selected initiative' },
    { name: 'toggle-expansion', description: 'Expand/Collapse selected initiative' },
    { name: 'view-item', description: 'View initiative details' },
    { name: 'done-undone-item', description: 'Mark initiative done/undone' },
    { name: 'edit-initiative', description: 'Edit the currently selected initiative' },
    { name: 'cancel-editing', description: 'Cancel editing of initiative' },
    { name: 'delete-initiative', description: 'Delete selected initiative' },
    { name: 'comment', description: 'Comment on selected initiative' }
  ]
}
